import { render } from "./BudgetModal.vue?vue&type=template&id=37fecdda"
import script from "./BudgetModal.vue?vue&type=script&lang=js"
export * from "./BudgetModal.vue?vue&type=script&lang=js"

import "./BudgetModal.vue?vue&type=style&index=0&id=37fecdda&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__